// Azure AD / Microsoft Entra ID SSO (OIDC authorization-code flow).
// Client side only builds the /authorize URL and redirects to Microsoft
// (state + nonce stashed in sessionStorage). The returned `code` is exchanged
// at the backend via the `loginWithAzure` RTK mutation on the callback page.

const cfg = {
  authority:
    process.env.NEXT_PUBLIC_AZURE_AUTHORITY || "https://login.microsoftonline.com",
  tenant: process.env.NEXT_PUBLIC_AZURE_TENANT_ID || "",
  clientId: process.env.NEXT_PUBLIC_AZURE_CLIENT_ID || "",
  redirectUri: process.env.NEXT_PUBLIC_AZURE_REDIRECT_URI || "",
  scopes: process.env.NEXT_PUBLIC_AZURE_SCOPES || "openid profile email",
};

export const azureRedirectUri = cfg.redirectUri;

export function isAzureConfigured(): boolean {
  return Boolean(cfg.tenant && cfg.clientId && cfg.redirectUri);
}

function randomString(): string {
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

/** Redirect the browser to the Microsoft sign-in page. */
export function startAzureLogin(): void {
  if (!isAzureConfigured()) {
    throw new Error(
      "Azure SSO is not configured (NEXT_PUBLIC_AZURE_TENANT_ID / _CLIENT_ID / _REDIRECT_URI)",
    );
  }

  const state = randomString();
  const nonce = randomString();

  // validated back on the callback page
  sessionStorage.setItem("azure_oauth_state", state);
  sessionStorage.setItem("azure_oauth_nonce", nonce);

  const params = new URLSearchParams({
    client_id: cfg.clientId,
    response_type: "code",
    redirect_uri: cfg.redirectUri,
    response_mode: "query",
    scope: cfg.scopes,
    state,
    nonce,
  });

  window.location.href = `${cfg.authority}/${cfg.tenant}/oauth2/v2.0/authorize?${params.toString()}`;
}
